module.exports = __webpack_public_path__ + "media/images/auth/circle_outer-b1e7bfc4e66fc79ee6d22d83b1525d85.svg";